import formatSortOrder from '../components/organisms/SearchResults/formatSortOrder';
import { showAllQuery } from './DataContext';
import isFacetSearchParam from '../components/templates/SearchForm/isFacetSearchParam';

/*
 * Transform front-end URL search params into args
 * to pass to getData() function.
 */
const composeRequestArgs = (searchParams) => {
  const query = searchParams.get('query')?.trim() ?? showAllQuery;

  const rawInitialOffset = Number(searchParams.get('start_rank'));
  const offset = rawInitialOffset && !isNaN(rawInitialOffset) ? rawInitialOffset : 1;

  const rawSortValue = searchParams.get('sort') ?? '';
  const sort = formatSortOrder(rawSortValue);

  const facets = {};
  searchParams.forEach((paramValue, paramKey) => {
    if (isFacetSearchParam(paramKey) && paramValue.trim()) {
      if (typeof facets[paramKey] === 'undefined') facets[paramKey] = [];
      facets[paramKey].push(paramValue);
    }
  });

  const initialRequest = { query, offset, params: facets, sort };
  return initialRequest;
};

export default composeRequestArgs;
